
/* eslint-disable import/no-anonymous-default-export */
export default {
    robb: '青萍室内环境检测仪',
    robb_banner_desc:'8 项数据，精准检测',
    robb_product_desc1:'温度 · 湿度 · PM2.5 · PM10{br}CO2 · eTVOC · 噪音 · 照度',
    robb_product_desc2:'墙壁安装 · 多种供电方式',
    robb_step1_name: '青萍室内环境检测仪',
    robb_step1_desc: '墙壁安装{spot}8 项读数{spot}多种供电方式{spot}可更换 PM 传感器',
    robb_step2_name: '2 种主机',
    robb_m_step1_desc_1: '墙壁安装',
    robb_m_step1_desc_2: '8 项读数',
    robb_m_step1_desc_3: '多种供电方式',
    robb_m_step1_desc_4: '可更换 PM 传感器',
    robb_step2_card_title: '墨水屏版',
    robb_step2_card_title2: '无屏幕版',
    robb_step2_card_i_text1: '超宽可视角度 ',
    robb_step2_card_i_text2: '超高对比度 ',
    robb_step2_card_i_text3: '彩色读数{br}评价灯条{note}',
    robb_step2_card_i_text4: '按钮切换读数',
    robb_step2_card_i_text5:  '彩色读数{br}评价灯条{note}',
    robb_step2_card_i_text6: '按钮查看联网状态',

    robb_step3_name: '3 种供电模块',
    robb_step3_desc: '主机机身和供电模块通过连接器连接。',
    robb_step3_card_title1: '墙壁底盒交流电源模块',
    robb_step3_card_title2: '墙壁底盒低压电源模块',
    robb_step3_card_title3: '壁装低压电源模块', 

    robb_pop_wall_box_h1: '墙壁底盒交流电源模块',
    robb_pop_wall_box_h2: '墙壁接线盒安装，可直接替代已有 “86 盒”*型墙壁插座。',
    robb_pop_wall_box_tab_1_1: 'RS-485{br2}有线通信接口',
    robb_pop_wall_box_tab_2_1: '支持{br2}100–240V 交流电',
    robb_pop_wall_box_footer_text: '* “86 盒”是一种常见的接线盒规格，尺寸为 86 × 86 毫米。兼容中国、欧洲、英国的同尺寸接线盒。',

    robb_pop_wall_box_low_volt_h1: '墙壁底盒低压电源模块',
    robb_pop_wall_box_low_volt_h2: '墙壁接线盒安装，可直接替代已有 “86 盒”*型墙壁插座。',
    robb_pop_wall_box_low_volt_tab_1_1: 'RS-485 有线通信接口',
    robb_pop_wall_box_low_volt_tab_2_1: '支持 9-24V 交流电{br}或 9–30V 直流电',
    robb_pop_wall_box_low_volt_footer_text: '* “86 盒”是一种常见的接线盒规格，尺寸为 86 × 86 毫米。兼容中国、欧洲、英国的同尺寸接线盒。',

    robb_pop_wall_mounted_h1: '壁装低压电源模块',
    robb_pop_wall_mounted_h2: '包装内有壁挂支架、双面胶和螺丝钉，可用于固定。',
    robb_pop_wall_mounted_tab_1_1: '支持 9–24V 交流电{br}或 9–30V 直流电',
    robb_pop_wall_mounted_tab_2_1: 'USB-C 供电接口',
    robb_pop_wall_mounted_footer_text: '灵活的壁装式设计，适用于多种安装环境。',

    robb_step4_title: '3 种无线通信方案供您选择{note}',
    robb_step4_wifi: '使用环境需有稳定的 Wi-Fi 信号。',
    robb_step4_lora: '需配备 LoRaWAN 网关或基站。',
    robb_step4_nbiot: '需当地中国移动提供相关网络服务{note}。',

    robb_step5_title: '8 项数据，精准监测',
    robb_step5_light: '照度',
    robb_step5_temp: '温湿度',
    robb_step5_co2: 'CO2',
    robb_step5_pm25: 'PM2.5 {br}和 PM10',
    robb_step5_tvoc: 'eTVOC{sup}',
    robb_step5_noise: '噪音',
    robb_step5_memo1:
      '温湿度不仅事关舒适性，也和健康息息相关。处于温湿度不佳的环境，可能引发睡眠问题，甚至过敏反应或呼吸道疾病等。',
      robb_step5_memo2:
      '室内 二氧化碳 浓度过高，容易使人困倦，也意味着通风不良、空气中其他污染物的积累。',
      robb_step5_memo3:
      '粒径小、活性强，易附着有害物质，被人吸入后，可能对呼吸系统和心血管系统产生不良影响。',
      robb_step5_memo4:
      '包含上千种化合物，其中部分物质可能有刺激性气味、部分物质可能对⼈体有害。',
      robb_step5_memo5:
      '噪音水平对人的睡眠质量和身体健康有影响。持续的噪音可能导致失眠、焦虑和压力增加。长时间暴露在噪音过高的环境会引起听力问题，甚至耳聋。',

    robb_step6_name:'可更换 PM 传感器，便于维护',
    robb_step6_desc:'采用高品质光学器件，搭配磁悬浮风扇，准确性、可靠性俱佳。',


    robb_step7_title:'青萍家{note}',
    robb_step7_desc:'管理青萍家用智能设备，支持查看数据、{br}修改设置、升级固件等。',

    robb_step10_name:'多场景专业应用',
    robb_step10_desc:'可广泛应用于家庭、学校、办公楼、医院、餐厅、商场、工厂、酒店、{br}实验室等场景。',
    robb_step10_banner1_footer:'检测办公室、学校教室的空气质量、照度、噪音水平等，适时采取改普措施，提供{br}健康舒适的工作、学习环境。',
    robb_step10_banner2_footer:'某些实验、测试和生产过程对环境温湿度有严格要求。监测并记录实验{br}室、工厂的温湿度，以及时了解和应对重大变化。',
    
    robb_step11_name:'阻燃材料，安全可靠',
    robb_step11_desc:'壳体材料具有出色的阻燃性、绝缘性，不易变形、褪色。',

    robb_step12_1:'通过彩色读数评价灯条指示室内环境水平，绿色为优、黄色为良、红色为差。可通过青萍物联 app 或网站修改读数评价标准。',
    robb_step12_2:'支持定制其他无线通信方案，如 Thread、Zigbee、Cat-1、Cat-M 等。',
    robb_step12_3:'NB-IoT 版设备出厂内置 SIM 卡，含 6 年中国移动 NB-IoT 流量资费（限 50MB/年）。不同批次所包含的资费可能不同。',
    robb_step12_4:'本产品采用的 TVOC 传感器会根据过去一段时间的读数水平自动调整测量基线，故本产品显示的是 eTVOC （即“TVOC 等效值”），并非准确的 TVOC 绝对读数，仅供用户观察环境 TVOC 浓度的相对变化趋势。',
    robb_step12_5:'仅 Wi-Fi 版本支持青萍家。',

    // specifications
    robb_size:'主机尺寸',
    robb_color:'颜色',
    robb_spec_size:'86 × 86 × 23 毫米',
    robb_color:'白色',
    robb_spec_long:'86 毫米',
    robb_spec_short:'23 毫米',
    robb_spec_height:'86 毫米',

    robb_temperature:'温度',
    robb_humidity:'湿度',
    robb_co2_range:'二氧化碳',
    robb_pm_range:'PM2.5/PM10',
    robb_etvoc_range:'eTVOC',
    robb_noise_range:'噪音',
    robb_light_range:'照度',
    
    robb_temperature_range:'无屏版：-10 ~ 60°C{br}墨水屏版：0 ~ 50°C',
    robb_humidity_range:'0 ~ 99%RH（无凝露环境）{br}{hint}',
    robb_humidity_hint:'* 请勿长时间在湿度超过 90%RH 的环境下使用',
    robb_co2_value:'400 ~ 9999 ppm',
    robb_pm_value:'0 ~ 999 μg/m³',
    robb_etvoc_value:'VOC 指数 0 ~ 500，或 0.005 ~ 9.999 mg/m³',
    robb_noise_value:'36 ~ 95 dB',
    robb_light_value:'0 ~ 83000 lux',

    screen_resolution:'屏幕分辨率',
    robb_screen_resolution:'152 × 296 像素',
    robb_weight:'113 克',
    robb_screen_size:'36 × 72 毫米',
    robb_wifi:'Wi-Fi 2.4GHz 或 NB-IoT（CMCC）或 LoRa',
    robb_ble:'蓝牙 5.0',

    robb_package_name:'室内环境检测仪{br}主机',
    robb_package_battery:'PM 传感器',
    robb_package_screen:'说明书',
    robb_package_screen_resolution:'螺丝刀{br}（仅用于安装小螺丝）',
    robb_package_weight:'小螺丝 × 2',
    robb_temp:'温度',
    robb_hum:'湿度',

    robb_step5_memo6: '过高或过低的光照强度可能导致眼部疲劳、学习和工作效率降低。过度使用照明设备，可能造成能源浪费。',

    robb_tab_1:'墙壁底盒交流电源模块',
    robb_tab_2:'墙壁底盒低压电源模块',   
    robb_tab_3:'壁装低压电源模块',   
    robb_tab1_size:'82 × 82 × 33 毫米',
    robb_tab1_color:'白色',
    robb_tab1_left:'82 毫米',
    robb_tab1_left2:'33 毫米',
    robb_tab1_left3:'82 毫米',
    wired_connect:'有线通信',
    input:'输入',
    robb_tab1_name:'青萍墙壁底盒交流电源模块',
    robb_tab1_weight:'62 克',
    robb_tab1_connect:'RS-485',
    robb_tab1_protect:'100–240V 交流电',
    robb_tab1_pack_7:'青萍墙壁底盒交流{br}电源模块',
    robb_tab1_pack_9:'大螺丝 × 4',
    robb_tab1_pack_10:'说明书',
    robb_tab2_name:'青萍墙壁底盒低压电源模块',
    robb_tab2_pack_7:'青萍墙壁底盒低压{br}电源模块',
    robb_tab2_protect:'9-24V 交流电或 9–30V 直流电',

    robb_tab3_size:'86 × 86 × 24 毫米',
    robb_tab3_color:'白色',
    robb_tab3_left:'86 毫米',
    robb_tab3_left2:'24 毫米',
    robb_tab3_left3:'86 毫米',
    robb_tab3_name: '青萍壁装低压电源模块',
    robb_tab3_weight: '57 g',
    robb_tab3_protect: '9–24V 交流电或 9–30V 直流电 或 USB-C 电源（5V⎓1A）',
    robb_tab3_pack_7:'青萍壁装低压电源模块',
    robb_tab3_pack_11:'壁装支架',

    exterior_robb:'外观',
    specifications_robb:'规格',
}